import type {
  OfferDto,
  OfferEntity,
  ProgressBarBreakpointConfig,
  ProgressBarConfig,
  ProgressBarDeviceConfig,
  ResolvedProgressBarDeviceConfig,
  ResolvedProgressBarWidgetConfig,
} from "@intelligems/ig-types";

import { createShippingProgressBarConfig } from "./createShippingProgressBarConfig";
import { getShippingThresholdByOffer } from "./getShippingThresholdByOffer";

export function createProgressBarConfigForOffer(
  offer: OfferDto | OfferEntity,
  widget: ResolvedProgressBarWidgetConfig,
  isEntireStore: boolean
): ProgressBarConfig | undefined {
  const { unitType, discountType } = offer;
  // @ts-ignore
  const afterDiscount = window.igSetup?.gwpAfterDiscount ?? false;

  if (widget.widgetType === "discountProgressBar") {
    const desktop = createOfferConfig(offer, widget.desktop);
    const mobile = createOfferConfig(offer, widget.mobile);
    return desktop && mobile
      ? {
          unitType,
          discountType,
          afterDiscount,
          isEntireStore,
          desktop,
          mobile,
        }
      : undefined;
  } else {
    const desktop = createShippingConfig(offer, widget.desktop);
    const mobile = createShippingConfig(offer, widget.mobile);
    return desktop && mobile
      ? {
          unitType,
          discountType,
          afterDiscount,
          isEntireStore,
          desktop,
          mobile,
        }
      : undefined;
  }
}

function createOfferConfig(
  offer: OfferDto,
  widget: ResolvedProgressBarDeviceConfig
): ProgressBarDeviceConfig | undefined {
  if (offer.tiers.length === 0) return undefined;

  const breakpoints: ProgressBarBreakpointConfig[] = offer.tiers.map((tier) => {
    const variableTier =
      widget.variables.textReplacements?.tierVariables?.[tier.id];
    return {
      value: tier.minimumUnits,
      label: variableTier?.tooltipTemplate,
      completeText: variableTier?.currentUnlockedTemplate,
      incompleteText: variableTier?.buyMoreTemplate,
      tooltipEnabled: variableTier?.tooltipEnabled,
      active: {
        iconId: variableTier?.activeIconId,
        backgroundIconId: variableTier?.activeBackgroundIconId,
      },
      inactive: {
        iconId: variableTier?.inactiveIconId,
        backgroundIconId: variableTier?.inactiveBackgroundIconId,
      },
      reward: {
        gwp: tier.isGiftWithPurchase,
        freeShipping: tier.isFreeShipping,
        discount: tier.unitDiscount,
      },
    };
  });
  return {
    breakpoints,
    widget,
  };
}

function createShippingConfig(
  offer: OfferDto,
  widget: ResolvedProgressBarDeviceConfig
): ProgressBarDeviceConfig | undefined {
  const threshold = getShippingThresholdByOffer(offer);
  if (threshold === undefined) return undefined;

  return createShippingProgressBarConfig(widget, threshold);
}
